export const ChatActionParam = Object.freeze({
	ChatAction: 'chatAction',
	EntityId: 'entityId',
	ChildrenIds: 'childrenIds',
});
